<script>
import AuthWrapper from '@/components/auth/AuthWrapper.vue';
import AuthService from '@/shared/services/auth.service';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'ForgotPassword',
  components: {
    AuthWrapper,
  },
  data() {
    return {
      email: '',
      processing: false,
      errorMessage: null,
      emailError: null,
      sent: false,
    };
  },
  methods: {
    validate() {
      const email = this.email.trim();

      if (!email) {
        this.emailError = 'Veuillez saisir votre adresse e-mail.';
      } else if (!EMAIL_PATTERN.test(email)) {
        this.emailError = 'Veuillez saisir une adresse e-mail valide.';
      } else {
        this.emailError = null;
      }

      return !this.emailError;
    },

    async handleReset() {
      this.errorMessage = null;

      if (!this.validate()) {
        return;
      }

      this.processing = true;

      try {
        // The response is deliberately the same whether or not the account
        // exists, so the form never reveals which emails are registered.
        await AuthService.requestPasswordReset(this.email.trim());
        this.sent = true;
        this.email = '';
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message ||
          'Erreur lors de la demande de réinitialisation.';
      } finally {
        this.processing = false;
      }
    },

    goToLogin() {
      this.$router.push({ path: '/login' });
    },
  },
};
</script>

<template>
  <AuthWrapper variant="form">
    <BCard no-body class="auth-page__card">
      <BCardBody class="auth-page__card-body">
        <div v-if="sent" class="auth-form__result">
          <div class="auth-form__icon">
            <i class="ri-mail-check-line"></i>
          </div>
          <h1 class="auth-form__title">E-mail envoyé !</h1>
          <p class="auth-form__body">
            Vérifiez votre boîte mail — nous vous avons envoyé un lien pour
            réinitialiser votre mot de passe.
          </p>
          <button class="auth-form__submit" type="button" @click="goToLogin">
            Retour à la connexion
          </button>
        </div>

        <div v-else>
          <div v-if="errorMessage" class="auth-form__alert" role="alert">
            {{ errorMessage }}
          </div>

          <div class="text-center">
            <div class="auth-page__logo mb-3">
              <img src="@/assets/images/logo_apii.png" alt="Logo APII" />
            </div>
            <h1 class="auth-form__title">Mot de passe oublié ?</h1>
            <p class="auth-form__subtitle">
              Saisissez votre adresse e-mail pour recevoir un lien de
              réinitialisation
            </p>
          </div>

          <form novalidate @submit.prevent="handleReset">
            <div class="auth-form__fields">
              <div class="auth-form__field">
                <label class="auth-form__label" for="email"
                  >Adresse e-mail</label
                >
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': emailError }"
                  :aria-invalid="Boolean(emailError)"
                  placeholder="Entrez votre adresse e-mail"
                  autocomplete="email"
                />
                <span v-if="emailError" class="auth-form__error">
                  {{ emailError }}
                </span>
              </div>
            </div>

            <button
              class="auth-form__submit"
              type="submit"
              :disabled="processing"
            >
              {{ processing ? 'Envoi en cours…' : 'Envoyer le lien' }}
            </button>

            <p class="auth-form__footnote">
              <router-link to="/login" class="auth-form__link">
                Retour à la connexion
              </router-link>
            </p>
          </form>
        </div>
      </BCardBody>
    </BCard>
  </AuthWrapper>
</template>
